import DeliveryModeList from "./DeliveryModeList";
import useDeliveryFulfillments from "../../contexts/DeliveryFulfillmentsContext";
import {
  DeliveryFulfillmentsScreenProps,
  deliveryFulfillmentsRoutes,
} from "../../navigation/types";

type Props = DeliveryFulfillmentsScreenProps<
  typeof deliveryFulfillmentsRoutes.deliveryModeList
>;
export default function DeliveryModeListScreen({ navigation }: Props) {
  const {
    navigateToLegacyFulfillment,
    automaticFulfillmentsEnabled,
    manualFulfillmentsEnabled,
  } = useDeliveryFulfillments();

  function navigateToAutomaticFulfillments() {
    navigation.navigate(deliveryFulfillmentsRoutes.automaticFulfillments);
  }

  return (
    <DeliveryModeList
      modes={{
        automatic: {
          enabled: automaticFulfillmentsEnabled,
          onPress: navigateToAutomaticFulfillments,
        },
        manual: {
          enabled: manualFulfillmentsEnabled,
          onPress: navigateToLegacyFulfillment,
        },
      }}
    />
  );
}
